import { render, staticRenderFns } from "./OrganizationLocations.vue?vue&type=template&id=64530de5&scoped=true"
import script from "./OrganizationLocations.vue?vue&type=script&lang=js"
export * from "./OrganizationLocations.vue?vue&type=script&lang=js"
import style0 from "./OrganizationLocations.vue?vue&type=style&index=0&id=64530de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64530de5",
  null
  
)

export default component.exports